import axios from 'axios'
import Future from 'fluture'
import {path, tap} from 'ramda'
import {getTokenQuery, getSessionToken, storeSessionToken} from './token'

const waitWhileUrlChanges = (location) => (x) =>
  location.href === `${location.origin}/`
    ? Future.of(x)
    : Future.after(1, x).chain(waitWhileUrlChanges(location))

export const cleanUrl = (location) => {
  if (location.search) {
    window.history.replaceState({}, document.title, location.origin)
  }
}

export const setupSession = (location: Object, token: string) => () => {
  cleanUrl(location)
  storeSessionToken(token)
}

export const main = (location, baseUrl, setupSession) => {
  const token = location.search
    ? getTokenQuery(location.search)
    : getSessionToken()

  if (!token) {
    return Future.reject(new Error('No token provided'))
  }

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  }

  return Future.encaseP2(axios.get)(`${baseUrl}users/login`, config)
    .map(tap(setupSession(location, token)))
    .chain(waitWhileUrlChanges(location))
    .map(path(['data']))
}



// WEBPACK FOOTER //
// ./src/main.js